import {GAME_TYPES} from "../../constants/game";

/**
 * Чей игрок «свой» для ленты «вы» (карточка в списке игроков, кружок в строке
 * игроков шапки). В сетевой партии — по пользователю; в локальной id игроков
 * свои, и «свой» — единственный живой игрок среди ботов (в hot-seat
 * нескольких людей своего нет, как и у зрителя)
 * @returns {string|null}
 */
export const getOwnPlayerId = (gameType, userId, players) => {
  if (userId && players.some((player) => player.id === userId)) {
    return userId;
  }
  const humanPlayers = players.filter((player) => !player.isBot);
  return gameType === GAME_TYPES.LOCAL && humanPlayers.length === 1 ? humanPlayers[0].id : null;
};
